import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {Prompt} from 'react-router-dom';
import SMCModal from '../../components/core/SMCModal';
import SMCButton from '../../components/Simple/SMCButton';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import {useBoolean} from '../../utils/hooks';
import {useTranslation} from 'react-i18next';
import RowLayout from '../../components/Layouts/RowLayout';
import ColumnLayout from '../../components/Layouts/ColumnLayout';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const RouteLeavingGuard = ({
    when,
    shouldBlockNavigation,
    navigateTo
}) => {
    const { t } = useTranslation();

    const [isConfirmationModalOpen, openConfirmationModal, closeConfirmationModal] = useBoolean(false);
    const [lastLocation, setLastLocation] = useState(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  
    const handleBlockedNavigation = (nextLocation) => {
        if (!confirmedNavigation && (!shouldBlockNavigation || shouldBlockNavigation(nextLocation))) {
            openConfirmationModal();
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    };

    const handleConfirmNavigationClick = () => {
        closeConfirmationModal();
        setConfirmedNavigation(true);
    };

    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            // Navigate to the previous blocked location
            navigateTo(lastLocation);
        }
    }, [confirmedNavigation, lastLocation, navigateTo]);

    return (
        <>
        <Prompt when={when} message={handleBlockedNavigation} />
        <SMCModal
            isOpen={isConfirmationModalOpen}
            onRequestClose={closeConfirmationModal}
            title={t('SMC_GEN_CONFIRM')}
            height={160}
            width={332}
        >
            <SMCModalBody style={{ paddingTop: '3px', paddingLeft: '15px', paddingBottom: '0px', lineHeight: '18px' }}>
                <RowLayout spacing="8px">
                    <FontAwesomeIcon color="#F7B63C" icon="exclamation-triangle" style={{ height: 35, width: '35px' }} />
                    <ColumnLayout>
                        <SMCLabel>{t('CORE.DIRTY_MESSAGE')}</SMCLabel>
                        <SMCLabel>{t('CORE.DIRTY_MESSAGE.ARE_YOU_SURE')}</SMCLabel>
                    </ColumnLayout>
                </RowLayout>
            </SMCModalBody>
            <SMCModalButtonContainer size="small">
                <SMCButton onClick={handleConfirmNavigationClick}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_YESNO_YES')}
                </SMCButton>
                <SMCButton onClick={closeConfirmationModal}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_YESNO_NO')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
        </>
    );
}

const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteLeavingGuard);